<template>
    <el-dialog class="tpl-hidden-dialog global-dialog"
               title="设置素材、文字显示/隐藏"
               width="650px"
               :visible.sync="dialogVisible">
        <div>
          <p>选择要显示/隐藏的素材、文字</p>
           <div>
               <el-radio-group v-model="checkedId" @change="onRadioGroupChange">
                   <el-radio v-for="item in data" :label="item.id" :key="item.key" class="check-item" :class="{'text-item': item.type === 'text'}">
                       <template  v-if="item.type === 'img'">
                           <span>{{item.name}}</span>
                           <div class="thd-imb-box">
                               <img :src="item.url"/>
                           </div>
                       </template>
                       <span v-else>{{item.name}}</span>
                   </el-radio>
               </el-radio-group>
           </div>
            <div>
                <p>素材/文字位置保留</p>
                <el-radio-group v-model="selfSet">
                    <el-radio :label="1">素材/文字展示位置保留</el-radio>
                    <el-radio :label="2">素材/文字展示位置同时隐藏</el-radio>
                </el-radio-group>
            </div>
            <div>
                <p>其它素材/文字是否隐藏</p>
                <el-radio-group v-model="otherSet">
                    <el-radio :label="1">仅隐藏当前素材/文字</el-radio>
                    <el-radio :label="2">同时隐藏同组素材/文字</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div slot="footer" class="twd-footer c-center">
            <el-button :type="checkedItem.hide ? 'primary':'default'" @click="onShow()" :disabled="!checkedItem.hide">显示</el-button>
            <el-button :type="checkedItem.hide ? 'default':'primary'"  @click="onHide" :disabled="checkedItem.hide">隐藏</el-button>
            <el-button  type="default" @click="onClose">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import TUtil from '../TUtil'
    import {minus_plus} from '@/const';
    export default {
        props: {
            value: {
                type: Boolean, default: false
            },
            data: Array,
            template: Object
        },
        data() {
            return {
                selfSet: 1,
                otherSet: 1,
                checkedId: null,
                checkedItem: {hide: false}
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
        },
        watch: {
            dialogVisible: {
                handler(v) {
                    if (v) {
                        this.$nextTick(() => {
                            this.init()
                        })
                    }
                },
                immediate: true
            }
        },
        methods: {
            init() {
            },
            _reset(){
                this.checkedId = null;
                this.checkedItem = {hide: false};
            },
            onShow(){
                this.setHidden(false);
                this.$emit('onConfirm');
                this.dialogVisible = false;
            },
            onHide(){
                this.setHidden(true);
                this.$emit('onConfirm');
                this.dialogVisible = false;
            },
            onClose(){
                this.dialogVisible = false;
            },
            setHidden(hide){
                if(!this.checkedId){
                    this.$message.error('请选择要操作的元素');
                    return;
                }
                this.$emit('onAddCache');
                let templateJson = this.template.json;
                let item = null;
                if(this.otherSet === 1){
                   item = this.checkedItem;
                   item.hide = hide;
                } else if(this.otherSet === 2) {
                    item = this.getParentItem(templateJson, this.checkedId);
                    if(item.children){
                        item.children.forEach((obj) => {
                            obj.hide = hide;
                        });
                    } else {
                        item.hide = hide;
                    }
                }
                if(this.selfSet === 2){
                    let textHeight = +item.height;
                    let minusOrPlus = hide ? minus_plus.minus : minus_plus.plus;
                    this.stopDeep = false;
                    TUtil.moveItem(templateJson, item, minusOrPlus, textHeight)
                }
            },
            getParentItem(templateJson, currentId){
                let parent = {};
                this.deepChildren(templateJson, currentId, parent);
                return parent;
            },
            deepChildren(item, currentId, parent){
                if(this.stopDeep){
                    return;
                }
                item.children && item.children.forEach((child) => {
                    if(child.id === currentId){
                        Object.assign(parent, item);
                        this.stopDeep = true;
                    } else if (child.children){
                        this.deepChildren(child, currentId, parent);
                    }
                });
            },
            onRadioGroupChange(checkedId){
                this.checkedItem = this.data.filter((obj) => {
                    return obj.id === checkedId;
                })[0];
            }
        }
    }
</script>
<style lang="scss">
    @import "./tpl-hidden-dialog";
</style>